import { useEffect, useState } from 'react';
import { PROJECT } from '~/constants';
import { useSignUpStepStore } from '~/store';
import InnerLayout from '../Layout/InnerLayout';
import * as S from './Agreement.styled';
import CheckList from './CheckList';
import TermsModalLayout from './TermsModal';

export type TermsType = 'privacyPolicy' | 'termsOfService';

interface AgreementProps {
  onNextStep: () => void;
}

export default function Agreement({ onNextStep }: AgreementProps) {
  const {
    agreement: { required, required2, marketing },
    setRequired,
    setRequired2,
    setMarketing,
  } = useSignUpStepStore((state) => ({
    agreement: state.agreement,
    setRequired: state.setRequired,
    setRequired2: state.setRequired2,
    setMarketing: state.setMarketing,
  }));

  const setSubProgress = useSignUpStepStore((state) => state.setSubProgress);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<TermsType>('termsOfService');

  const isRequiredChecked = required && required2;

  useEffect(() => {
    const progress = isRequiredChecked ? 1 : 0.5;
    setSubProgress(progress);
  }, [isRequiredChecked, setSubProgress]);

  const handleClickModalType = (type: TermsType) => {
    setModalType(type);
    setShowModal(true);
  };

  const checklistData = [
    {
      id: 'SignUpRequiredTerm',
      checked: required,
      onChange: setRequired,
      label: (
        <span className='required'>
          [Requirement] I agree with the {PROJECT}{' '}
          <p onClick={() => handleClickModalType('termsOfService')}>Terms</p> of
          Use and the{' '}
          <p onClick={() => handleClickModalType('privacyPolicy')}>
            Privacy Policy
          </p>
          .
        </span>
      ),
    },
    {
      id: 'SignUpRequiredTerm2',
      checked: required2,
      onChange: setRequired2,
      label: (
        <span className='required'>
          [Requirement] Avatars created on {PROJECT} may be provided to other
          users.
        </span>
      ),
    },
    {
      id: 'SignUpMarketingTerm',
      checked: marketing,
      onChange: setMarketing,
      label: (
        <span>
          [Optional] I agree to the {PROJECT} Marketing Terms and Conditions.
        </span>
      ),
    },
  ];

  return (
    <>
      <InnerLayout
        buttonProps={{
          title: 'Agree and Continue',
          disabled: !isRequiredChecked,
          onClick: onNextStep,
        }}
      >
        <S.Container>
          <S.CheckListWrapper>
            {checklistData.map(({ id, checked, onChange, label }) => (
              <CheckList
                key={id}
                id={id}
                checked={checked}
                onChange={onChange}
                label={label}
              />
            ))}
          </S.CheckListWrapper>
        </S.Container>
      </InnerLayout>
      <TermsModalLayout
        type={modalType}
        isOpen={showModal}
        setIsOpen={setShowModal}
      />
    </>
  );
}
